import { render, staticRenderFns } from "./DeleteQuantity.vue?vue&type=template&id=a9683c04"
import script from "./DeleteQuantity.vue?vue&type=script&lang=js"
export * from "./DeleteQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports